module.exports = __webpack_public_path__ + "img/mail_mailcontract.d88bfc2.png";